module.exports = __webpack_public_path__ + "static/media/customerprofile.98a9f5f3.png";